// // /*********************
//  * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
//  * __________________
//  *
//  *  Mobillor Technologies Pvt. Ltd.
//  *  All Rights Reserved.
//  *
//  * NOTICE:  All information contained herein is, and remains
//  * the property of Mobillor Technologies Pvt. Ltd.
//  * The intellectual and technical concepts contained
//  * herein are proprietary to Mobillor Technologies Pvt. Ltd.
//  * may be covered by Rebublic Of India and Foreign Patents,
//  * patents in process, and are protected by trade secret or copyright law.
//  * Dissemination of this information or reproduction of this material
//  * is strictly forbidden unless prior written permission is obtained
//  * from Mobillor Technologies Pvt. Ltd.
//  */

import { useEffect, useState } from "react";

import { connect } from "react-redux";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";

// React-Select component and styling
import Select from "react-select";
import "../../../index.css";

//  formik and yup
import { useFormik } from "formik";
import * as Yup from "yup";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import Icon from "@mui/material/Icon";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import TextError from "utils/TextError";

import { Tree } from "primereact/tree";

// Functions from store
import {
  createAdminRoles,
  deleteRoles,
  editUserRolesForAdmin,
  getAdminModuleForView,
  getAllRoles,
  getDepartments,
  getModuleDataForUserDetails,
  getModuleForCreateRoleInClient,
  getModuleForEdit,
  getModuleForView,
  getModules,
  getModulesForCreate,
  getSubModule,
  getSubModuleForCreateRole,
  getSubModuleForView,
  getSubModulesByRoleId,
  getUserRoles,
} from "../../../store";

import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import EditButton from "components/standardized-components/EditButton";
import ViewButton from "components/standardized-components/ViewButton";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const ClientRoles = ({
  getAllRolesReducer,
  getAllRoles,
  deleteRoles,
  createRoles,
  editUserRolesForAdmin,
  getModules,
  getModulesReducer,
  getSubModule,
  getSubModulesReducer,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getAdminModuleForView,
  getSubModuleForView,
  getSubModulesForViewReducer,
  getModuleForView,
  createAdminRoles,
  getModulesForViewReducer,
  getModuleForEdit,
  getModulesForEditReducer,
  getModulesForEditRolesForUserReducer,
  getCreateRolesReducer,
  getSubModuleForCreateRole,
  getSubModulesForCreateRoleReducer,
  getAdminModuleRolesReducer,
  getDepartments,
  getUserRoles,
  getModulesForCreate,
  getUserRolesReducer,
  getModuleRolesReducer,
  departments,
  getModuleForCreateRoleInClient,
  getModuleDataForUserDetails,
}) => {
  const deleteStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: 340, sm: 340, md: 340, lg: 330, xl: 330 },
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  const styleForCreateRole = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: 340, sm: 340, md: 450, lg: 450, xl: 450 },
    height: "fit-content",
    maxHeight: { xs: 340, sm: 340, md: 440, lg: 600, xl: 600 },
    boxShadow: 24,
    p: 1,
    pt: 2,
  };

  let data = cookies.get("loginDetailsForWMS");

  let jwtToken = data?.jwt;
  let roleId = data.data.roleId;
  let roleName = data?.data?.roleName;
  let adminRoleId = data?.data?.roleId;

  let clientId = data.data.clientId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);
  useEffect(() => {
    getModuleForCreateRoleInClient(roleId, clientId, jwtToken);
  }, [roleId, clientId]);
  useEffect(() => {
    getModulesForCreate(roleId, clientId, jwtToken);
  }, [roleId, clientId]);

  const [modulesAccessData, setModulesAccessData] = useState([]);

  useEffect(() => {
    setModulesAccessData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  useEffect(() => {
    getUserRoles(clientId, jwtToken);
  }, [clientId]);

  const [submitLoader, setSubmitLoader] = useState(false);

  const [productsData, setProductsData] = useState({});

  const [roleDataForEdit, setRoleDataForEdit] = useState({});
  const [roleIdForView, setRoleIdForView] = useState("");

  const [clientIdForView, setClientIdForView] = useState("");
  const [moduleIdForView, setModuleIdForView] = useState("");
  let [roleIdForUpdate, setRoleIdForUpdate] = useState("");
  let [moduleIdForUpdate, setModuleIdForUpdate] = useState("");

  useEffect(() => {
    getModuleForView(roleIdForView, clientIdForView, jwtToken);
  }, [roleIdForView, clientIdForView]);

  useEffect(() => {
    getAdminModuleForView(roleIdForView, clientIdForView, jwtToken);
  }, [roleIdForView, clientIdForView]);

  useEffect(() => {
    getAllRoles(jwtToken);
  }, [getAllRoles]);

  useEffect(() => {
    getSubModuleForCreateRole(jwtToken);
  }, [getSubModuleForCreateRole]);

  let [subModuleForCreateRole, setSubModuleForCreateRole] = useState({});

  // useEffect(async () => {
  //   let tempSubModulesData = {};
  //   let subModulesData = await getSubModuleForCreateRole(jwtToken);
  //   tempSubModulesData["subModulesForCreateRole"] = subModulesData.data;
  //   setSubModuleForCreateRole(tempSubModulesData);
  // }, []);

  useEffect(() => {
    getSubModule(jwtToken, roleIdForUpdate, moduleIdForUpdate);
  }, [getSubModule, roleIdForUpdate, moduleIdForUpdate]);

  // useEffect(() => {
  //   getModuleForEdit(jwtToken, roleIdForView);
  // }, [getModuleForView, roleIdForView]);

  let payload = { roleId: roleIdForView, moduleId: moduleIdForView };

  useEffect(() => {
    getSubModuleForView(jwtToken, payload);
  }, [getSubModuleForView, roleIdForView, moduleIdForView]);

  let subModuleDataForView = getSubModulesForViewReducer?.subModuleData?.data
    ? getSubModulesForViewReducer?.subModuleData?.data
    : [];

  let moduleDataForView = getAdminModuleRolesReducer?.rolesData?.data
    ? getAdminModuleRolesReducer?.rolesData?.data
    : [];

  let moduleDataForEdit = getModulesForEditRolesForUserReducer?.rolesData?.data
    ? getModulesForEditRolesForUserReducer?.rolesData?.data
    : [];

  let viewLoading = getAdminModuleRolesReducer?.loading;
  let editLoading = getModulesForEditReducer?.loading;

  // let subModuleDataForCreate =getCreateRolesReducer

  let subModuleDataForCreate = getCreateRolesReducer?.createRoles?.data
    ? getCreateRolesReducer?.createRoles?.data
    : [];
  let createLoading = getModuleRolesReducer?.loading;

  // const [modulesDataForView, setModulesDataForView] = useState([]);
  // useEffect(async () => {
  //   let tempModulesData = {};
  //   let modulesData = await getModuleForView(jwtToken, roleIdForView);
  //   tempModulesData["ModulesForView"] = modulesData.data;
  //   setModulesDataForView(tempModulesData);
  // }, [roleIdForView]);

  const [departmentSelected, setDepartmentSelected] = useState({});
  const handleDepartmentSelected = (selectedOption) => {
    setDepartmentSelected(selectedOption);
  };

  const [departmentsOptions, setDepartmentsOptions] = useState([]);
  useEffect(() => {
    let tempDepartments = departments.departments.data
      ? departments.departments.data
      : [];
    let departmentOptionsTemp = [];
    tempDepartments.map((department) => {
      departmentOptionsTemp.push({
        label: department.departmentName,
        value: department.departmentId,
      });
    });
    setDepartmentsOptions(departmentOptionsTemp);
  }, [departments]);

  let userModule = modulesAccessData.find(
    (moduleId) => moduleId.moduleId == "428d1fae-c385-4576-8e00-77c60ec81ff2",
  );

  let createAccess = userModule
    ? userModule.actionId.includes("069a46e0-11b2-4163-ac29-30b57a5e02df")
    : null;
  // let createAccess=true

  let viewAccess = userModule
    ? userModule.actionId.includes("8c265949-cefd-45e7-bab9-bb1b6aa75e60")
    : null;
  // let viewAccess=true

  let updateAccess = userModule
    ? userModule.actionId.includes("ddfa8765-be39-40d2-b10a-fd637a864ac6")
    : null;

  let deleteAccess = userModule
    ? userModule.actionId.includes("bc85b3c1-9820-492e-a81b-405cb52ab8c9")
    : null;

  const [loading, setLoading] = useState(true);

  // const [nodes, setNodes] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState(moduleDataForEdit);

  useEffect(() => {
    setSelectedKeys(moduleDataForEdit);
  }, [getModulesForEditRolesForUserReducer]);

  let payloadArr = [];

  Object.keys(selectedKeys).forEach(
    (key) => (selectedKeys[key].actionId = key),
  );

  Object.values(selectedKeys).forEach((el) => payloadArr.push(el));

  const [opendeleteRolesModal, setOpendeleteRolesModal] = useState(false);
  const [singleClientDataForDelete, setClientDataForDelete] = useState({});

  const handleOpendeleteRolesModal = (department = {}) => {
    setClientDataForDelete(department);
    setOpendeleteRolesModal(true);
  };

  const handleClosedeleteRolesModal = () => {
    setOpendeleteRolesModal(false);
  };
  const [isErrordeleteRoles, setIsErrordeleteRoles] = useState(false);

  useEffect(() => {
    if (isErrordeleteRoles) {
      setTimeout(() => {
        setIsErrordeleteRoles(false);
      }, 3000);
    }
  }, [isErrordeleteRoles]);

  const [deleteErrorMsg, setDeleteErrorMsg] = useState("");

  const deleteRolesData = async () => {
    let roleId = singleClientDataForDelete.roleId;
    let response = await deleteRoles(jwtToken, roleId);
    if (response.status) {
      handleClosedeleteRolesModal();
      getUserRoles(clientId, jwtToken);
    }
    if (!response.status) {
      setDeleteErrorMsg(response.data.data.message);
      setIsErrordeleteRoles(true);
    }
  };

  const [openEditRoleModal, setOpenEditRoleModal] = useState(false);
  const [clientIdForEdit, setClientIdForEdit] = useState(false);
  const [roleIdForEdit, setRoleIdForEdit] = useState(false);

  const handleOpenEditRoleModal = (data) => {
    setOpenEditRoleModal(true);
    setRoleDataForEdit(data);
    setDepartmentSelected({
      label: data.departmentName,
      value: data.departmentId,
    });
    setRoleIdForUpdate(data.roleId);
    setRoleIdForView(data.roleId);

    setClientIdForEdit(data.clientId);
    setRoleIdForEdit(data.roleId);
    getModuleForEdit(roleIdForEdit, jwtToken);
    getModuleDataForUserDetails(roleIdForEdit, clientIdForEdit, jwtToken);
    setSelectedKeys(moduleDataForEdit);
  };

  const handleCloseEditRoleModal = () => {
    setOpenEditRoleModal(false);
    setSelectedKeys(moduleDataForEdit);
    getUserRoles(clientId, jwtToken);
    getModuleForEdit(roleIdForEdit, jwtToken);
    getModuleDataForUserDetails(roleIdForEdit, clientIdForEdit, jwtToken);
    setSelectedKeys("");
    formik.setValues(initialValues);
    formik.setTouched({});
    formik.setErrors({});
  };

  const [isSuccessEditRole, setIsSuccessEditRole] = useState(false);
  const [isErrorEditRole, setIsErrorEditRole] = useState(false);

  useEffect(() => {
    if (isSuccessEditRole) {
      setTimeout(() => {
        setIsSuccessEditRole(false);
      }, 3000);
    }
  }, [isSuccessEditRole]);

  useEffect(() => {
    if (isErrorEditRole) {
      setTimeout(() => {
        setIsErrorEditRole(false);
      }, 3000);
    }
  }, [isErrorEditRole]);

  const initialValues = {
    roleName: roleDataForEdit ? roleDataForEdit.roleName : "",
    description: roleDataForEdit ? roleDataForEdit.description : "",
    departmentId: roleDataForEdit ? roleDataForEdit.departmentId : "",
  };

  const validationSchema = Yup.object({
    roleName: Yup.string().required("Enter the role name"),
    description: Yup.string().required("Enter the description"),
  });

  const [editErrorMsg, setEditErrorMsg] = useState("");

  const onSubmit = async (values, { resetForm }) => {
    // setSubmitLoader(true);

    const actionIds = payloadArr.map((actionId) => actionId);
    const payload = {
      roleName: values.roleName,
      description: values.description,
      departmentId: "",
      clientId: clientIdForEdit,
      roleId: roleIdForEdit,
      actionIds: actionIds,
      adminRoleId: adminRoleId,
    };
    let response = await editUserRolesForAdmin(payload, jwtToken);
    if (response.status === true) {
      setSubmitLoader(false);
      setIsSuccessEditRole(true);

      getUserRoles(clientId, jwtToken);
      setTimeout(() => {
        handleCloseEditRoleModal();
      }, 2250);
      setRoleIdForUpdate("");
      // setModuleIdForUpdate("");
      // getSubModuleForView(jwtToken, payload);
      getAdminModuleForView(roleIdForView, clientIdForView, jwtToken);
      getUserRoles(clientId, jwtToken);
      // getSubModule(jwtToken, roleIdForUpdate, moduleIdForUpdate);
      // getSubModulesByRoleId(roleId, jwtToken);
      // getModules(jwtToken);
      resetForm();
    }
    if (response.status === false) {
      setEditErrorMsg(response.data.data.message);
      setSubmitLoader(false);
      setIsErrorEditRole(true);
    }
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: onSubmit,
    validationSchema: validationSchema,
    enableReinitialize: true,
  });

  //    create role
  const [openCreateRoleModal, setOpenCreateRoleModal] = useState(false);

  const handleOpenCreateRoleModal = (data) => {
    setRoleIdForUpdate(data?.roleId);
    setOpenCreateRoleModal(true);
    setDepartmentSelected("");
    setSelectedKeys("");
  };

  const handleCloseCreateRoleModal = () => {
    setOpenCreateRoleModal(false);
    setSelectedKeys("");
    getUserRoles(clientId, jwtToken);
    formikForCreateRole.setValues(initialValuesForCreateRole);
    formikForCreateRole.setTouched({});
    formikForCreateRole.setErrors({});
  };

  const [isSuccessCreateRole, setIsSuccessCreateRole] = useState(false);
  const [isErrorCreateRole, setIsErrorCreateRole] = useState(false);
  useEffect(() => {
    if (isSuccessCreateRole) {
      setTimeout(() => {
        setIsSuccessCreateRole(false);
      }, 3000);
    }
  }, [isSuccessCreateRole]);

  useEffect(() => {
    if (isErrorCreateRole) {
      setTimeout(() => {
        setIsErrorCreateRole(false);
      }, 3000);
    }
  }, [isErrorCreateRole]);

  const initialValuesForCreateRole = {
    roleName: "",
    description: "",
    departmentId: "",
  };

  const validationSchemaForCreateRole = Yup.object({
    roleName: Yup.string().required("Enter the role name"),
    description: Yup.string().required("Enter the description"),
  });

  useEffect(() => {
    getModuleForEdit(roleIdForEdit, jwtToken);
  }, [roleIdForEdit, clientIdForEdit]);

  useEffect(() => {
    getModuleDataForUserDetails(roleIdForEdit, clientIdForEdit, jwtToken);
  }, [roleIdForEdit, clientIdForEdit]);

  // seEffect(() => {
  //   getModuleForEdit(jwtToken, roleIdForView);
  // }, [getModuleForView, roleIdForView]);

  const [createErrorMsg, setCreateErrorMsg] = useState("");

  const onSubmitForCreateRole = async (values, { resetForm }) => {
    setSubmitLoader(true);

    const actionIds = payloadArr.map((actionId) => actionId);

    const payload = {
      roleName: values.roleName,
      departmentId: "",
      description: values.description,
      clientId: clientId,
      actionIds: actionIds,
    };

    let response = await createAdminRoles(payload, jwtToken);

    if (response.status === true) {
      setSubmitLoader(false);
      setIsSuccessCreateRole(true);
      getUserRoles(clientId, jwtToken);
      setTimeout(() => {
        handleCloseCreateRoleModal();
      }, 2260);
      resetForm();
      setSubModulesActionsForCreateRole([]);
      getSubModuleForView(jwtToken, payload);
      getAdminModuleForView(roleIdForView, clientIdForView, jwtToken);
      getSubModule(jwtToken, roleIdForUpdate, moduleIdForUpdate);
      getSubModulesByRoleId(roleId, jwtToken);
      getModules(jwtToken);
    }
    if (!response.status) {
      setCreateErrorMsg(response.data.data.message);
      setSubmitLoader(false);
      setIsErrorCreateRole(true);
    }
  };

  const formikForCreateRole = useFormik({
    initialValues: initialValuesForCreateRole,
    onSubmit: onSubmitForCreateRole,
    validationSchema: validationSchemaForCreateRole,
  });

  const selectCrudOperation = (a) => {};
  const [openCrudOperationModal, setOpenCrudOperationModal] = useState(false);

  const handleOpenCrudOperationModal = (data) => {
    setOpenCrudOperationModal(true);
  };

  const handleCloseCrudOperationModal = () => {
    setOpenCrudOperationModal(false);
  };

  let [productsList, setProductsList] = useState([]);
  let [modules, setModules] = useState({});
  let [modulesForView, setModulesForView] = useState({});

  let [subModule, setSubModule] = useState({});

  // submodules ka data
  let subModulesData = getSubModulesReducer?.subModulesData?.data
    ? getSubModulesReducer?.subModulesData?.data
    : [];

  const [testingData, setTestingData] = useState([]);
  const [testSubModule, setTestSubModule] = useState(subModulesData || []);

  const [modulesActions, setModulesActions] = useState([]);
  const [subModulesActions, setSubModulesActions] = useState([]);
  const [subModulesActionsForCreateRole, setSubModulesActionsForCreateRole] =
    useState([]);

  const [parentModuleId, setParentModuleId] = useState("");

  const [itemTable, setItemTable] = useState({
    columns: [
      { Header: "role name", accessor: "roleName" },
      { Header: "description", accessor: "description" },
      {
        Header: "action",
        accessor: "action",
        align: "center",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns: itemColumns, rows: itemRows } = itemTable;

  useEffect(() => {
    let tempRoles = [];
    let data = getUserRolesReducer?.rolesData?.data
      ? getUserRolesReducer?.rolesData?.data
      : [];
    // setLoading(getUserRolesReducer.loading);

    if (getUserRolesReducer?.rolesData?.data?.length) {
      data?.map((data) => {
        const singledata = {
          roleName: data.roleName,
          description: data.description,

          action: (
            <>
              <span style={{ display: "flex" }}>
                {viewAccess ? (
                  <ViewButton
                    tooltip="View"
                    style={{ marginLeft: "10px" }}
                    variant="gradient"
                    color="info"
                    iconOnly
                    type="button"
                    onClick={() => handleopenViewModal(data)}
                  >
                    <Icon> visibility_icon </Icon>
                  </ViewButton>
                ) : (
                  <ViewButton
                    tooltip="View"
                    disabled
                    style={{ marginLeft: "10px" }}
                    variant="gradient"
                    color="info"
                    iconOnly
                    type="button"
                    onClick={() => handleopenViewModal(data)}
                  >
                    <Icon> visibility_icon </Icon>
                  </ViewButton>
                )}
                {updateAccess && (
                  <EditButton
                    tooltip="Edit Role"
                    // style={{ marginLeft: "10px" }}
                    variant="gradient"
                    color="success"
                    iconOnly
                    disabled={data.isAdmin ? true : false}
                    type="button"
                    onClick={() => {
                      handleOpenEditRoleModal(data);
                      getDepartments(jwtToken);
                    }}
                    style={{
                      marginLeft: "0.1rem",
                      // background: data.isAdmin = true ? "grey" : "",
                      // color: "white",
                      // opacity: 0.5,
                    }}
                    // style={{
                    // marginLeft: "5rem",
                    // marginLeft: data.isAdmin === true ? "0.5rem" : "0.5rem",
                    // background: data.isAdmin = true ? "grey" : undefined,
                    // color: to.isAdmin === 1 ? "white" : undefined,
                    // opacity: to.isAdmin === 1 ? 0.5 : undefined,
                    // }}
                  >
                    <Icon> edit </Icon>
                  </EditButton>
                )}

                {deleteAccess && (
                  <DeleteButton
                    tooltip="Delete Role"
                    style={{ marginLeft: "3px" }}
                    variant="gradient"
                    color="error"
                    iconOnly
                    disabled={data.isAdmin ? true : false}
                    type="button"
                    onClick={() => handleOpendeleteRolesModal(data)}
                  >
                    <DeleteIcon />
                  </DeleteButton>
                )}
              </span>
            </>
          ),
        };
        tempRoles.push(singledata);
      });
    }
    viewAccess && setItemTable({ ...itemTable, rows: tempRoles });
  }, [getUserRolesReducer]);

  const [openViewModal, setopenViewModal] = useState(false);

  const handleopenViewModal = (data = {}) => {
    setRoleIdForView(data.roleId);
    setClientIdForView(data.clientId);
    setopenViewModal(true);
  };

  const handleCloseViewModal = () => {
    setopenViewModal(false);
    getUserRoles(clientId, jwtToken);
    getSubModuleForView(jwtToken, payload);
    getAdminModuleForView(roleIdForView, clientIdForView, jwtToken);
    getSubModule(jwtToken, roleIdForUpdate, moduleIdForUpdate);
    getSubModulesByRoleId(roleId, jwtToken);
    getModules(jwtToken);
  };

  return (
    <>
      <>
        <MDBox mt={-8}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              {createAccess && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  p={3}
                >
                  <MDBox>
                    <CreateButton
                      tooltip="Create Role"
                      color="info"
                      variant="contained"
                      type="button"
                      onClick={() => {
                        handleOpenCreateRoleModal();
                        getDepartments(jwtToken);
                      }}
                    >
                      <Icon>add</Icon>
                    </CreateButton>
                  </MDBox>
                </MDBox>
              )}
              <MDBox mt={createAccess ? -3 : 0}>
                {/* {!loading ? ( */}
                <DataTable
                  table={{ columns: itemColumns, rows: itemRows }}
                  isSorted={true}
                  tableSearch={true}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                />
                {/* ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "100px",
                      marginBottom: "100px",
                    }}
                  >
                    <CircularProgress color="info" />
                  </div>
                )} */}
              </MDBox>
            </Grid>
            <Grid>
              <Modal
                open={opendeleteRolesModal}
                onClose={handleClosedeleteRolesModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={deleteStyle}>
                  <MDTypography>Are you sure you want to delete?</MDTypography>
                  <MDBox mt={2}>
                    <div style={{ display: "flex" }}>
                      <div>
                        <MDButton
                          style={{ width: "100%", marginRight: "0.5rem" }}
                          color="info"
                          variant="outlined"
                          onClick={handleClosedeleteRolesModal}
                        >
                          Cancel
                        </MDButton>
                      </div>
                      <div>
                        <MDButton
                          style={{ width: "100%", marginLeft: "0.5rem" }}
                          color="error"
                          onClick={deleteRolesData}
                        >
                          Delete
                        </MDButton>
                      </div>
                    </div>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isErrordeleteRoles}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrordeleteRoles(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {/* Please check the details. Server error! */}
                        {deleteErrorMsg}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
            </Grid>

            <Modal
              open={openCreateRoleModal}
              onClose={handleCloseCreateRoleModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForCreateRole}>
                <MDBox ml={1} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Create Role
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseCreateRoleModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>

                <hr />

                <MDBox pt={1} pb={3} px={1} overflow="auto">
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForCreateRole.handleSubmit}
                  >
                    <MDBox mb={2}>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        flexGrow={1}
                        style={{ fontWeight: "500" }}
                      >
                        Role Name
                      </MDTypography>

                      <MDInput
                        type="text"
                        name="roleName"
                        fullWidth
                        autoComplete="off"
                        onChange={formikForCreateRole.handleChange}
                        onBlur={formikForCreateRole.handleBlur}
                        value={formikForCreateRole.values.roleName}
                        error={
                          formikForCreateRole.touched.roleName &&
                          formikForCreateRole.errors.roleName &&
                          true
                        }
                        inputProps={{
                          maxLength: 45,
                        }}
                      />
                      {formikForCreateRole.touched.roleName &&
                        formikForCreateRole.errors.roleName && (
                          <TextError
                            msg={formikForCreateRole.errors.roleName}
                          />
                        )}
                    </MDBox>
                    <MDBox mb={2}>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        flexGrow={1}
                        style={{ fontWeight: "500" }}
                      >
                        Description
                      </MDTypography>

                      <MDInput
                        // type="text"
                        name="description"
                        fullWidth
                        autoComplete="off"
                        onChange={formikForCreateRole.handleChange}
                        onBlur={formikForCreateRole.handleBlur}
                        value={formikForCreateRole.values.description}
                        error={
                          formikForCreateRole.touched.description &&
                          formikForCreateRole.errors.description &&
                          true
                        }
                        inputProps={{
                          maxLength: 45,
                        }}
                      />
                      {formikForCreateRole.touched.description &&
                        formikForCreateRole.errors.description && (
                          <TextError
                            msg={formikForCreateRole.errors.description}
                          />
                        )}
                    </MDBox>

                    {roleName === "super" ? (
                      <MDBox mb={2}>
                        <MDTypography
                          variant="h6"
                          fontWeight="medium"
                          style={{ fontWeight: "500" }}
                        >
                          Select Component
                        </MDTypography>
                        <Select
                          isMulti
                          isClearable
                          className="select-css"
                          maxMenuHeight={130}
                          placeholder="Choose one..."
                          name="departmentId"
                          // options={departmentsOptions}
                          // value={departmentSelected}
                          // onChange={(selectedOption) => {
                          //   handleDepartmentSelected(selectedOption);
                          //   formikForCreateRole.setFieldValue(
                          //     "departmentId",
                          //     selectedOption
                          //   );
                          // }}
                        />
                        {formikForCreateRole.errors.departmentId && (
                          <TextError
                            msg={formikForCreateRole.errors.departmentId}
                          />
                        )}
                      </MDBox>
                    ) : (
                      // <MDBox mb={2}>
                      //   <MDTypography
                      //     variant="h6"
                      //     fontWeight="medium"
                      //     style={{ fontWeight: "500" }}
                      //   >
                      //     Department Name
                      //   </MDTypography>
                      //   <Select
                      //     isClearable
                      //     className="select-css"
                      //     maxMenuHeight={130}
                      //     placeholder="Choose one..."
                      //     name="departmentId"
                      //     options={departmentsOptions}
                      //     value={departmentSelected}
                      //     onChange={(selectedOption) => {
                      //       handleDepartmentSelected(selectedOption);
                      //       formikForCreateRole.setFieldValue(
                      //         "departmentId",
                      //         selectedOption
                      //       );
                      //     }}
                      //   />
                      //   {formikForCreateRole.errors.departmentId && (
                      //     <TextError
                      //       msg={formikForCreateRole.errors.departmentId}
                      //     />
                      //   )}
                      // </MDBox>
                      ""
                    )}
                    <MDBox mb={0}>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        style={{ fontWeight: "500" }}
                      >
                        Modules
                      </MDTypography>
                    </MDBox>

                    <div className="card flex justify-content-center">
                      <Tree
                        value={subModuleDataForCreate}
                        selectionMode="checkbox"
                        selectionKeys={selectedKeys}
                        onSelectionChange={(e) => setSelectedKeys(e.value)}
                        className="w-full md:w-30rem p5"
                        filter
                        filterMode="lenient"
                      />
                    </div>

                    {/* {productsList ? getMainAccordionForCreateRole() : null} */}

                    <MDBox ml={2} mr={2}>
                      <MDBox></MDBox>
                    </MDBox>

                    <MDBox>
                      <Collapse in={isErrorCreateRole}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorCreateRole(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {/* Please check the details. Server error! */}
                          {createErrorMsg}
                        </Alert>
                      </Collapse>
                      <Collapse in={isSuccessCreateRole}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsSuccessCreateRole(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Role created successfully
                        </Alert>
                      </Collapse>
                    </MDBox>
                    <MDBox mt={2}>
                      {!submitLoader ? (
                        <MDButton
                          variant="contained"
                          color="info"
                          fullWidth
                          type="submit"
                          disabled={!formikForCreateRole.isValid}
                        >
                          Submit
                        </MDButton>
                      ) : (
                        <MDButton
                          variant="contained"
                          color="info"
                          fullWidth
                          type="submit"
                          disabled={!formikForCreateRole.isValid}
                        >
                          <CircularProgress
                            style={{ color: "white", marginRight: "10px" }}
                            size={20}
                          />
                          Submiting...{" "}
                        </MDButton>
                      )}
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>

            {/* ///////////////// edited model ------------- */}
            <Modal
              open={openEditRoleModal}
              onClose={handleCloseEditRoleModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForCreateRole}>
                <MDBox ml={1} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Edit Role
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseEditRoleModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>

                <hr />

                <MDBox pt={1} pb={3} px={1} overflow="auto">
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formik.handleSubmit}
                  >
                    <MDBox mb={2}>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        flexGrow={1}
                        style={{ fontWeight: "500" }}
                      >
                        Role Name
                      </MDTypography>

                      <MDInput
                        type="text"
                        name="roleName"
                        fullWidth
                        autoComplete="off"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.roleName}
                        error={
                          formik.touched.roleName &&
                          formik.errors.roleName &&
                          true
                        }
                        inputProps={{
                          maxLength: 45,
                        }}
                      />
                      {formik.touched.roleName && formik.errors.roleName && (
                        <TextError msg={formik.errors.roleName} />
                      )}
                    </MDBox>
                    <MDBox mb={2}>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        flexGrow={1}
                        style={{ fontWeight: "500" }}
                      >
                        Description
                      </MDTypography>

                      <MDInput
                        // type="text"
                        name="description"
                        fullWidth
                        autoComplete="off"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.description}
                        error={
                          formik.touched.description &&
                          formik.errors.description &&
                          true
                        }
                        inputProps={{
                          maxLength: 45,
                        }}
                      />

                      {formik.touched.description &&
                        formik.errors.description && (
                          <TextError msg={formik.errors.description} />
                        )}
                    </MDBox>
                    {/* <MDBox mb={2}>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        style={{ fontWeight: "500" }}
                      >
                        Department Name
                      </MDTypography>
                      <Select
                        isClearable
                        className="select-css"
                        maxMenuHeight={130}
                        placeholder="Choose one..."
                        name="departmentId"
                        options={departmentsOptions}
                        value={departmentSelected}
                        onChange={(selectedOption) => {
                          handleDepartmentSelected(selectedOption);
                          formik.setFieldValue("departmentId", selectedOption);
                        }}
                      />
                      {formik.errors.departmentId && (
                        <TextError msg={formik.errors.departmentId} />
                      )}
                    </MDBox> */}

                    <MDBox mb={0}>
                      <MDTypography variant="h6" fontWeight="medium">
                        Module
                      </MDTypography>
                    </MDBox>
                    {!editLoading ? (
                      <div className="card flex justify-content-center">
                        <Tree
                          value={subModuleDataForCreate}
                          selectionMode="checkbox"
                          selectionKeys={selectedKeys}
                          onSelectionChange={(e) => setSelectedKeys(e.value)}
                          className="w-full md:w-30rem"
                          filter
                          filterMode="lenient"
                        />
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginTop: "100px",
                          marginBottom: "100px",
                        }}
                      >
                        <CircularProgress color="info" />
                      </div>
                    )}
                    {/* <MDBox>{productsList ? getMainAccordion() : null}</MDBox> */}
                    <MDBox>
                      <Collapse in={isErrorEditRole}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorEditRole(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {/* Please check the details. Server error! */}
                          {editErrorMsg}
                        </Alert>
                      </Collapse>
                      <Collapse in={isSuccessEditRole}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsSuccessEditRole(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Role updated successfully
                        </Alert>
                      </Collapse>
                    </MDBox>
                    <MDBox mt={2}>
                      {!submitLoader ? (
                        <MDButton
                          variant="contained"
                          color="success"
                          fullWidth
                          type="submit"
                          disabled={!formik.isValid}
                        >
                          Update
                        </MDButton>
                      ) : (
                        <MDButton
                          variant="contained"
                          color="success"
                          fullWidth
                          type="submit"
                          disabled={!formik.isValid}
                        >
                          <CircularProgress
                            style={{ color: "white", marginRight: "10px" }}
                            size={20}
                          />
                          Updating...{" "}
                        </MDButton>
                      )}
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Grid>
              <Modal
                open={openViewModal}
                onClose={handleCloseViewModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForCreateRole}>
                  <MDBox ml={1} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      View Access Module
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseViewModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            padding: "5px",
                            marginBottom: "5px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>

                  <hr />

                  <MDBox t={1} pb={3} px={1} overflow="auto">
                    <MDCard>
                      <MDBox mt={2}>
                        <div>
                          <MDCard>
                            <MDCard>
                              <MDCard>
                                <MDBox>
                                  <MDBox mb={0}>
                                    <MDTypography
                                      variant="h6"
                                      fontWeight="medium"
                                    >
                                      Modules
                                    </MDTypography>
                                  </MDBox>

                                  {!viewLoading ? (
                                    <div className="card flex justify-content-center">
                                      <Tree
                                        value={moduleDataForView}
                                        selectionMode="none"
                                        className="w-full md:w-30rem"
                                      />
                                    </div>
                                  ) : (
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        marginTop: "100px",
                                        marginBottom: "100px",
                                      }}
                                    >
                                      <CircularProgress color="info" />
                                    </div>
                                  )}
                                  {/* {productsList
                                    ? getMainAccordionForView()
                                    : null} */}
                                </MDBox>
                              </MDCard>
                            </MDCard>
                          </MDCard>
                        </div>
                      </MDBox>
                    </MDCard>
                  </MDBox>
                </MDCard>
              </Modal>
            </Grid>
          </Grid>
        </MDBox>
      </>
      {/* {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )} */}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getAllRolesReducer: state.getAllRolesReducer,
    getModulesReducer: state.getModulesReducer,
    getSubModulesReducer: state.getSubModulesReducer,
    getSubModulesForViewReducer: state.getSubModulesForViewReducer,
    getModulesForViewReducer: state.getModulesForViewReducer,
    getSubModulesForCreateRoleReducer: state.getSubModulesForCreateRoleReducer,
    departments: state.getDepartmentsReducer,
    getAdminModuleRolesReducer: state.getAdminModuleRolesReducer,
    getUserRolesReducer: state.getUserRolesReducer,
    getModuleRolesReducer: state.getModuleRolesReducer,
    getModulesForEditReducer: state.getModulesForEditReducer,
    getModulesForEditRolesForUserReducer:
      state.getModulesForEditRolesForUserReducer,
    getCreateRolesReducer: state.getCreateRolesReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    deleteRoles: (jwtToken, productId) =>
      dispatch(deleteRoles(jwtToken, productId)),
    getAllRoles: (jwtToken) => dispatch(getAllRoles(jwtToken)),
    createAdminRoles: (payload, jwtToken) =>
      dispatch(createAdminRoles(payload, jwtToken)),
    editUserRolesForAdmin: (payload, jwtToken) =>
      dispatch(editUserRolesForAdmin(payload, jwtToken)),
    getModules: (jwtToken) => dispatch(getModules(jwtToken)),
    getSubModuleForCreateRole: (jwtToken) =>
      dispatch(getSubModuleForCreateRole(jwtToken)),
    getSubModule: (jwtToken, roleId, moduleId) =>
      dispatch(getSubModule(jwtToken, roleId, moduleId)),
    getModuleForEdit: (roleId, jwtToken) =>
      dispatch(getModuleForEdit(roleId, jwtToken)),
    getModuleForView: (roleIdForView, clientIdForView, jwtToken) =>
      dispatch(getModuleForView(roleIdForView, clientIdForView, jwtToken)),
    getAdminModuleForView: (roleId, clientId, jwtToken) =>
      dispatch(getAdminModuleForView(roleId, clientId, jwtToken)),
    getSubModuleForView: (jwtToken, payload) =>
      dispatch(getSubModuleForView(jwtToken, payload)),
    getDepartments: (jwtToken) => dispatch(getDepartments(jwtToken)),
    getUserRoles: (clientId, jwtToken) =>
      dispatch(getUserRoles(clientId, jwtToken)),
    getModuleForCreateRoleInClient: (roleId, clientId, jwtToken) =>
      dispatch(getModuleForCreateRoleInClient(roleId, clientId, jwtToken)),
    getModulesForCreate: (roleId, clientId, jwtToken) =>
      dispatch(getModulesForCreate(roleId, clientId, jwtToken)),
    getModuleDataForUserDetails: (roleId, clientId, jwtToken) =>
      dispatch(getModuleDataForUserDetails(roleId, clientId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(ClientRoles);
